export default "__VITE_ASSET__CLC6Xu6V__"